<template>
  <div>
    <div class='setBgImg' :style='`height:${height+50}px`'>
      <div class='showView' :style="`height:${height+30}px;width:${width-30}px`">
        <div class='userInfoWrap'>
          <div class='userData'></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '../../axios.js'
export default {
  props:{
    width:Number,
    height:Number
  },
  data(){
    return{
      height:0
    }
  },
  created(){
    this.getUserInfo()
  },
  methods:{
    getUserInfo(){
      axios.get('/wechat/info/getUserInfo').then(res=>{
        if(res.code==200){
          console.log(res)
        }
      })
    }
  }
}
</script>

<style>
  .userInfoWrap{
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center
  }
  .userData{
    height: 90%;
    width:60%;
    min-width: 500px;
    margin-top: 40px;
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
  } 
</style>
